<template>
  <div style="height: 100%">
    <div class="p-head">
      <span class="btn q" @click="handleCancel">取消</span>
      <span class="title">{{ title }}</span>
      <span class="btn w" @click="handleConfirm"
        >完成({{ selectedArr.length }}/100)</span
      >
    </div>
    <div class="main">
      <div class="s-column first">
        <p
          class="s-item"
          :class="{ active: currentFirst == first.name }"
          v-for="first in tree"
          :key="first.code"
          @click="currentFirst = first.name"
        >
          {{ first.name }}
        </p>
      </div>
      <div class="s-column second">
        <p
          class="s-item"
          :class="{ active: currentSecond == second.name }"
          v-for="second in secondArr"
          :key="second.code"
          @click="currentSecond = second.name"
        >
          {{ second.name }}
        </p>
      </div>
      <div class="s-column third">
        <p
          class="s-item"
          :class="{ active: isInArray(selectedArr, third.name) }"
          v-for="third in thirdArr"
          :key="third.code"
          @click="handleSelect(third.name)"
        >
          {{ third.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    tree: Array,
  },
  data() {
    return {
      selectedArr: [],
      currentFirst: "",
      currentSecond: "",
      secondArr: [],
      thirdArr: [],
    };
  },
  created() {
    this.currentFirst = this.tree[0].name;
  },
  watch: {
    currentFirst(val) {
      this.secondArr = this.tree.find((item) => {
        return item.name == val;
      }).children;
      this.currentSecond = this.secondArr[0].name;
    },
    currentSecond(val) {
      this.thirdArr = this.secondArr.find((item) => {
        return item.name == val;
      }).children;
    },
  },
  methods: {
    // 判断是否已存在在数组中
    isInArray(arr, item) {
      return arr.some((e) => e === item);
    },
    handleSelect(name) {
      if (this.isInArray(this.selectedArr, name)) {
        let index = this.selectedArr.indexOf(name);
        this.selectedArr.splice(index, 1);
      } else {
        this.selectedArr.push(name);
      }
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$emit("confirm", this.selectedArr);
    },
  },
};
</script>

<style lang="less" scoped>
.p-head {
  padding: 16px;
  text-align: center;
  border-bottom: solid 1px #ebeef5;
  overflow: hidden;
  .title {
    font-weight: bold;
    font-size: 16px;
  }
  .btn {
    cursor: pointer;
    &.q {
      float: left;
      // visibility: hidden;
    }
    &.w {
      float: right;
      color: #ec345c;
    }
  }
}
.main {
  display: flex;
  height: calc(100% - 54px);
  .s-column {
    flex: 1;
    height: 100%;
    text-align: center;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 3px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
    &.second {
      border-left: solid 1px #ebeef5;
      border-right: solid 1px #ebeef5;
    }
    .s-item {
      padding: 10px 3px;
      cursor: pointer;
      &.active {
        color: #ec345c;
      }
    }
  }
}
</style>